export const AdminLogLevelType = {
	info: 0,
	warn: 1,
	error: 2,
}